export default "__VITE_ASSET__6c887713__"